import { type IconName, iconPaths } from "./iconPaths.ts";

/** A Material icon in the current text colour; [label] makes it visible to screen readers. */
export function Icon({ name, size = 22, label }: { name: IconName; size?: number; label?: string }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <path d={iconPaths[name]} />
    </svg>
  );
}
